import React, { useState } from "react";
import { Link } from "react-router-dom";
import { NotificationContainer, StyledContainer, StyledPasswordReset } from "./passwordReset.style";
import { FixelLogo, FormContainer, Row, StyledButton, StyledInput, StyledLabel, StyledLeftForm, StyledRightForm } from "../signIn/signin.style";
import Firebase from "../../../services/firebase";
import Recommendation from "../../commons/recommendation/Recommendation.component";
import { ActionRow, ErrorContainer, StyledTitle } from "../../style/global.style";
import SmallLoader from "../../../components/utils/SmallLoader";

const PasswordReset = () => {
	const [email, setEmail] = useState("");
	const [emailHasBeenSent, setEmailHasBeenSent] = useState(false);
	const [error, setError] = useState(null);
	const [showSpinner, setShowSpinner] = useState(false);
	const onChangeHandler = (event) => {
		const { name, value } = event.currentTarget;
		if (name === "userEmail") {
			setEmail(value);
		}
	};
	const sendResetEmail = (event) => {
		event.preventDefault();
		setShowSpinner(true);
		Firebase.auth
			.sendPasswordResetEmail(email)
			.then(() => {
				setEmailHasBeenSent(true);
			})
			.catch(() => {
				setError("Error resetting password");
			})
			.finally(() => {
				setShowSpinner(false);
			});
	};

	return (
		<StyledPasswordReset>
			<FixelLogo />
			<StyledContainer>
				<StyledLeftForm>
					{emailHasBeenSent && <NotificationContainer>An email has been sent to you!</NotificationContainer>}
					{error && <ErrorContainer className={"shake"}>{error}</ErrorContainer>}
					{!emailHasBeenSent && !error && <div></div>}
					<FormContainer>
						<form action="">
							<StyledTitle>Reset your Password</StyledTitle>
							<StyledLabel htmlFor="userEmail">Email:</StyledLabel>
							<StyledInput type="email" name="userEmail" id="userEmail" value={email} placeholder="Input your email" onChange={onChangeHandler} />
						</form>
						<Row>
							<StyledButton
								className="w-full bg-blue-400 text-white py-3"
								disabled={showSpinner}
								onClick={(event) => {
									sendResetEmail(event);
								}}>
								{showSpinner ? <SmallLoader /> : "Send me a reset link"}
							</StyledButton>
							<ActionRow>
								<Link to="/" Style={"color: #3A5558"}>
									&larr; back to sign in
								</Link>
							</ActionRow>
						</Row>
					</FormContainer>
				</StyledLeftForm>
				<StyledRightForm>
					<Recommendation />
				</StyledRightForm>
			</StyledContainer>
		</StyledPasswordReset>
	);
};
export default PasswordReset;
